import FormControl from "@mui/material/FormControl";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import _ from "lodash";
import React from "react";
import { NumericFormat } from "react-number-format";

import TaskToolTip from "./taskToolTip";
import HelperText from "../../../../../../components/feedback/helper-text/";

function getUnitPropertie(fieldProperties, constraintId) {
  let model =
    fieldProperties &&
    _.find(fieldProperties.properties, function (a) {
      return a.id === constraintId;
    });
  model = model && model.value;
  return model;
}

function NumberFormatCustom(props) {
  const { fieldProperties } = props;
  const { inputRef, onChange, ...other } = props;

  let sthousandSeparator = getUnitPropertie(
    fieldProperties,
    "thousandSeparator",
  );
  let decimalSeparator = getUnitPropertie(fieldProperties, "decimalSeparator");
  const sdecimalScale = getUnitPropertie(fieldProperties, "decimalScale");
  const sallowNegative = getUnitPropertie(fieldProperties, "allowNegative");
  const propertiePrefix = getUnitPropertie(fieldProperties, "prefix");
  const smaxLength = getUnitPropertie(fieldProperties, "maxLength");

  decimalSeparator = sthousandSeparator === "." ? "," : decimalSeparator;

  if (sthousandSeparator === decimalSeparator) {
    decimalSeparator = decimalSeparator != null ? "," : decimalSeparator;
    sthousandSeparator = sthousandSeparator != null ? "." : sthousandSeparator;
  }

  return (
    <NumericFormat
      {...other}
      getInputRef={props.inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      thousandSeparator={sthousandSeparator || false}
      {...{ decimalSeparator }}
      decimalScale={sdecimalScale}
      maxLength={smaxLength}
      allowNegative={sallowNegative || false}
      isNumericString
      prefix={propertiePrefix || ""}
    />
  );
}

function TaskFieldInputNumber(props) {
  const handleOnChange = (event) => {
    const { onChange, attributes } = props;
    const value = event.target.value;
    const camundaValue = { type: getfieldType(), value, valueInfo: {} };
    const formatedValue = value;

    onChange && onChange(attributes.id, formatedValue, camundaValue);
  };

  const getfieldType = () => {
    const { fieldProperties } = props;
    const sdecimalScale = getUnitPropertie(fieldProperties, "decimalScale");

    if (sdecimalScale) {
      return "Double";
    }
    return "Long";
  };

  const handleOnBlur = (event) => {
    const { attributes, fieldProperties, OnBlur } = props;
    OnBlur && OnBlur(attributes.id, event.target.value, fieldProperties);
  };

  const {
    showValidate,
    error,
    value,
    readOnly,
    className,
    attributes,
    toolTip,
    style,
    id,
    fullWidth,
    fieldProperties,
    isPreview,
  } = props;

  const label = getUnitPropertie(fieldProperties, "label");
  const isRequired = getUnitPropertie(fieldProperties, "isRequired");

  const formatedValue = value === null ? "" : value;

  let errorComponent = error;
  let showValidateComponent = showValidate;

  const regex = getUnitPropertie(fieldProperties, "regex");

  if (isPreview && formatedValue && formatedValue.length > 0) {
    const re = new RegExp(regex);
    if (re.test(formatedValue)) {
      errorComponent = undefined;
      showValidateComponent = false;
    } else {
      const messageRegex = getUnitPropertie(fieldProperties, "messageRegex");
      errorComponent = messageRegex;
      showValidateComponent = true;
    }
  }
  return (
    <TaskToolTip title={toolTip}>
      <FormControl
        key={"divPadrao" + attributes.id}
        margin="normal"
        fullWidth={fullWidth}
      >
        <InputLabel htmlFor={label} shrink required={isRequired}>
          {label}
        </InputLabel>
        {showValidateComponent && errorComponent ? (
          <Input
            id={id}
            value={formatedValue}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            errorComponent={!!errorComponent}
            readOnly={readOnly}
            className={className}
            style={style}
            inputComponent={NumberFormatCustom}
            inputProps={{ fieldProperties }}
          />
        ) : (
          <Input
            id={id}
            value={formatedValue}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            errorComponent={undefined}
            readOnly={readOnly}
            className={className}
            style={style}
            inputComponent={NumberFormatCustom}
            inputProps={{ fieldProperties }}
          />
        )}
        {showValidateComponent && errorComponent && (
          <HelperText>{errorComponent}</HelperText>
        )}
      </FormControl>
    </TaskToolTip>
  );
}

// const mapStateToProps = createStructuredSelector({
//   value: (state, props) => selectFilterFormValuesSelector(state, props.id),
//   //component : (state, props) => selectFilterFormComponentSelector(state, props.id)
// });
//
// const mapDispatchToProps = {};

export default TaskFieldInputNumber;
